import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useClickOutside } from "../../hooks/useOutsideClick";
import { useRef } from "react";
import { setInteracting } from "../../redux/slices/gift";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

function PopupCard({ onClose }) {
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  const popupRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useClickOutside(popupRef, onClose, ["special-offers-fab"]);

  const handleDepositClick = () => {
    dispatch(setInteracting("deposit"));
    if (!isAuthenticated) {
      navigate("/login");
    } else {
      navigate("/wallet");
    }
    onClose();
  };

  const handleSignupClick = () => {
    navigate("/signup");
    onClose();
  };

  return (
    <>
      <style>{`
      @keyframes gradientMove {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      .animate-gradient {
        background-size: 200% 200%;
        animation: gradientMove 5s ease infinite;
      }
    `}</style>

      <div
        ref={popupRef}
        className="
        rounded-2xl p-4 mb-2 w-[calc(100%-5rem)] sm:w-[calc(100%-10rem)] md:w-72
        shadow-2xl animate-fadeIn 
        absolute top-1/2 left-1/2 
        -translate-x-1/2 -translate-y-1/2  md:top-auto md:left-auto 
        md:-translate-x-0 md:-translate-y-0
        md:bottom-44 md:right-0
        overflow-hidden border-2 border-yellow-400
        bg-black/90
        animate-gradient z-50
      "
      >
        <div className="flex justify-between items-center mb-3">
          <h4 className="text-white text-[15px] font-bold">
            🎁 Exclusive Bonuses
          </h4>

          <IconButton onClick={onClose} className="block md:!hidden m-0">
            <Close />
          </IconButton>
        </div>

        <div className="flex flex-col gap-3">
          {/* Card 1 */}
          <div
            onClick={handleDepositClick}
            className="
  p-4 rounded-xl 
  text-white shadow-lg cursor-pointer
  hover:scale-105 active:scale-95 transition-all
  border-2 border-yellow-400 
  bg-black
  animate-gradient
  text-center
  "
          >
            <p className="text-[15px] font-bold leading-tight">
              🔥 Get 100% Bonus 🔥
            </p>
            <p className="text-[13px] font-bold leading-tight mt-1">
              On your first deposit up to $100
            </p>
          </div>

          {/* Card 2 */}
          {!isAuthenticated && (
            <div
              onClick={handleSignupClick}
              className="
  p-4 rounded-xl 
  text-white shadow-lg cursor-pointer
  hover:scale-105 active:scale-95 transition-all
  border-4 border-yellow-400 
  bg-black
  animate-gradient
  text-center
"
            >
              <p className="text-[15px] font-bold leading-tight">
                🔥 Welcome Bonus 🔥
              </p>
              <p className="text-[13px] font-bold leading-tight mt-1">
                $1 instant bonus on sign-up
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default PopupCard;
